import styled from 'styled-components';
import { colorText } from '@atlas-frontend/design-tokens';

export const TextNormal = styled.span`
  color: ${colorText};
`;
